import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import UserService from '../Service/api.user';
//Private route validation
//TODO Route auth
const isAuthenticated = true;
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => {
    return (
      UserService.getUserFromSession() != null
        ? <Component {...props} />
        : <Redirect to='/auth/signin-1' />
    )
  }} />
)

export default PrivateRoute;